import get from 'lodash/get';
import React from 'react';
import returnNull from '../../atoms/null';
import { buildEffectiveSubscription, SUBSCRIPTION_LAYOUTS } from './constants';

interface IProps {
  subscriptionConfig?: object;
  data?: {
    lavish?: object;
    concrete?: object;
    loginlessFlat?: object;
    loginlessGrouped?: object;
  };
}

export const Subscription = ({ subscriptionConfig, data }: IProps) => {
  const rows = get(subscriptionConfig, ['subscription', 'rows'], []);
  const subRow = rows.find((r: any) => SUBSCRIPTION_LAYOUTS.includes(r.layout));
  const isLoginlessEnabled = get(
    subscriptionConfig,
    ['subscription', 'pageSetting', 'enableLoginlessSubscription'],
    false
  );
  const defaultLayout = isLoginlessEnabled ? 'LoginlessFlat' : 'Lavish';
  const layout = get(subRow, ['layout'], defaultLayout);
  let SubscriptionComponent;
  let updatedData;

  switch (layout) {
    case 'Concrete':
      SubscriptionComponent = window?.QT_COMPONENTS?.Concrete || returnNull;
      updatedData = data?.concrete;
      break;
    case 'Minimalist':
      SubscriptionComponent = window?.QT_COMPONENTS?.Minimalist || returnNull;
      updatedData = data?.concrete;
      break;
    case 'LoginlessFlat':
      SubscriptionComponent = window?.QT_COMPONENTS?.LoginlessFlat || returnNull;
      updatedData = data?.loginlessFlat;
      break;
    case 'LoginlessGrouped':
      SubscriptionComponent = window?.QT_COMPONENTS?.LoginlessGrouped || returnNull;
      updatedData = data?.loginlessGrouped;
      break;
    default:
      SubscriptionComponent = window?.QT_COMPONENTS?.Lavish || returnNull;
      updatedData = data?.lavish;
      break;
  }

  const rawSubscription = get(subscriptionConfig, ['subscription'], {}) as any;
  const effectiveSubscription = buildEffectiveSubscription(rawSubscription, isLoginlessEnabled);

  const props = {
    ...updatedData,
    config: { 'pagebuilder-config': { subscription: effectiveSubscription } },
    enableDarkMode: get(subscriptionConfig, ['enableDarkModePreview'], false)
  };

  return <SubscriptionComponent {...props} />;
};
